import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  EndCustomerRoute,
  EndCustomerPathName,
} from '@/modules/ta/endcustomer/endcustomer.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${EndCustomerRoute.ENDCUSTOMERS}`,
      name: EndCustomerPathName.ENDCUSTOMERS,
      component: () =>
        import(/* webpackChunkName: "endcustomers-page" */ './pages/EndCustomersPage.vue'),
    },
    {
      path: `/${EndCustomerRoute.ENDCUSTOMERS}/new`,
      name: EndCustomerPathName.ENDCUSTOMERFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "endcustomer-form-page" */ '@/modules/ta/endcustomer/pages/EndCustomerFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${EndCustomerRoute.ENDCUSTOMERS}/:id`,
      name: EndCustomerPathName.ENDCUSTOMERFORM,
      component: () =>
        import(
          /* webpackChunkName: "endcustomer-form-page" */ '@/modules/ta/endcustomer/pages/EndCustomerFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.LEADDETAILS
);
